
































import { Component, Prop, Vue } from "vue-property-decorator";
import {AppealCustomFields} from "@/models/appeals";

@Component({
  computed: {
    hasMask() {
      return (this.item['маска'] || "") != "";
    }
  }
})
class TextCustomField extends Vue {
  [x: string]: any;

  @Prop({ default: false }) readonly textarea!: boolean;
  @Prop({ required: true }) readonly item!: AppealCustomFields;
  @Prop({ default: "" }) readonly fieldName!: string;
  @Prop({ default: false }) readonly required!: boolean;
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: () => [] }) errorMessages: any;

  value = "";

  mounted() {
    this.value = this.item['значение'] || this.item['поУмолчанию'] || "";
    this.setValue();
  }

  setValue() {
    this.item['значение'] = this.value;
    this.item['ошибка'] = "";
  }

  /**
   * Валидация маски
   * @param v
   */
  isValidMask(v) {
    const mask = this.item['маска'].split('.').map(el => el.split('*').join('.+')).join('\\.') + '$';
    const pattern = new RegExp(mask, 'i');
    return pattern.test(v);
  }

  textRule() {
    let rules = [
      v => (!this.hasMask || v == "") || this.isValidMask(v) || "Некорректная маска (" + this.item['маска'] + ")",
    ];
    if (this.required) {
      rules.push(v => !!v || "Заполните данное поле");
    }
    return rules;
  }
}

export default TextCustomField;
